import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async login(user) {
    const response = await api.post(API_URL + "login", user);
    if (response.data.access_token) {
      localStorage.setItem("userF", JSON.stringify(response.data.access_token));
    }
  },

  async logout() {
    try {
      await api.post(API_URL + "logout", {});
    } finally {
      localStorage.removeItem("userF");
    }
  },

  async register(user) {
    const response = await api.post(API_URL + "register", user);
    if (response.data) return response.data;
  },

  async claveOlvidada(user) {
    const response = await api.post(API_URL + "claveOlvidada", user);
    if (response.data) return response.data;
  },

  async codigoRecuperado(user) {
    const response = await api.post(API_URL + "codigoRecuperado", user);
    if (response.data) return response.data;
  },

  async validaCodigo(user) {
    const response = await api.post(API_URL + "validaCodigo", user);
    if (response.data) return response.data;
  },

  async recordarCodigo(user) {
    const response = await api.post(API_URL + "recordarCodigo", user);
    if (response.data) return response.data;
  },

  async establecerClave(user) {
    const response = await api.post(API_URL + "establecerClave", user);
    if (response.data) return response.data;
  },

  async validaTelefonoUsuario(telefono) {
    const response = await api.post(API_URL + "validaTelefonoUsuario", telefono);
    if (response.data) return response.data;
  },

  async me() {
        const response = await api.get(API_URL + "me", { headers: { Accept: "application/vnd.api+json" } });
    return response.data;
  },

  async registroEmailSuscripcion(data) {
    const response = await api.post(API_URL + "public/registro-email", data);
    return response.data;
  },

  async registroRapido(data) {
    const response = await api.post(API_URL + "public/registro-rapido", data);
    if (response.data?.access_token) {
      localStorage.setItem("userF", JSON.stringify(response.data.access_token));
      localStorage.setItem("usuarioEmail", data.email || "");
    }
    return response.data;
  },

  async activarCuentaEmail(token) {
    const response = await api.post(API_URL + "public/activar-cuenta", { token });
    return response.data;
  },
};
